module.exports = __webpack_public_path__ + "85b05cdd0265bf3eba53dd1b3d05dbaf.svg";